var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-menubar" },
    _vm._l(_vm.menus, function (menu) {
      return _c(
        "b-dropdown",
        {
          key: menu.id,
          staticClass: "vks-menu",
          attrs: {
            text: menu.label,
            variant: "outline-secondary",
            size: "sm",
            "menu-class": "vks-menu-list",
            "toggle-class": "vks-menu-toggle",
          },
        },
        [
          _vm._l(menu.items, function (item) {
            return [
              item.type === "divider"
                ? _c("b-dropdown-divider", { key: item.id })
                : item.type === "header"
                ? _c("b-dropdown-header", { key: item.id }, [
                    _vm._v(" " + _vm._s(item.label) + " "),
                  ])
                : _c(
                    "b-dropdown-item",
                    {
                      key: item.id,
                      attrs: {
                        disabled: Boolean(item.disabled),
                        title: item.title || item.label,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSelect(menu, item)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.label) + " ")]
                  ),
            ]
          }),
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }